// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q2-1";
export var stateContainer = "_q2-0";